import type {
  DemoOverlay,
  IDemo,
  PlayAsset,
  Playbook,
  PlaybookAssetType,
  Tour,
} from '@carboncopyco/types';
import type { Entity } from './types';

export const getEntityType = (demo: Entity) => {
  if ('recordingType' in demo) {
    return 'demo' as PlaybookAssetType;
  }
  if ('tourName' in demo) {
    return 'tour' as PlaybookAssetType;
  }
  if ('name' in demo) {
    return 'externalUrl' as PlaybookAssetType;
  }
  return null;
};

export const getEntityTitle = (entity: Entity | Playbook) => {
  if ('demoName' in entity) {
    return entity.demoName;
  }
  if ('tourName' in entity) {
    return entity.tourName;
  }
  if ('name' in entity) {
    return entity.name;
  }
  return null;
};

export const getAssetType = (asset: IDemo | DemoOverlay | Tour | Playbook) => {
  if ('recordingType' in asset) {
    return 'demo';
  }
  if ('tourName' in asset) {
    return 'tour';
  }
  if ('name' in asset) {
    return 'playbook';
  }
};

export const adaptDemoToPlay = (demo: IDemo): PlayAsset => {
  return {
    name: demo.demoName,
    type: 'demo',
    id: String(demo.id),
    assets: [
      {
        assetId: String(demo.id),
        assetRevisionId: demo.revisionId,
        assetType: 'demo',
        autoSync: false,
        entity: demo,
      },
    ],
  };
};
